import React, { useContext, useEffect, useState } from "react";
import { Button } from "../../../../../../stories/Button/Button";
import { Title } from "../../../../../../stories/Title/Title";
import Close from "../../../../../../images/Close.svg";
import Input from "../../../../../../stories/Input/Input";
import { useLazyQuery, useMutation } from "@apollo/client";
import
{
  EmpMasterOrderField,
  EmpQueryType,
  GetEmpResult,
  GetEmpVars,
} from "../../../users/queries/types";
import { GetEmp } from "../../../users/queries/queries";
import useUrlParams from "../../../../../../customHooks/useUrlParams";
import
{
  debouncedDelay,
  EMPTY_STRING,
  emptyMessage,
  ROWS_PER_PAGE,
  TicketStatus,
} from "../../../../../../utils/constants";
import { empType, Operation } from "../../../../../../utils/Enum.types";
import { OrderDirection } from "../../../../../../utils/commonQueryTypes";
import Assign from "../../../../../../images/Assign.svg";
import { StateTypes } from "../../../maps/ticketing/history/AddFollowUpStatus";
import
{
  AddTicketDetailsResult,
  AddTicketDetailsVariables,
} from "../../../masters/items/queries/types";
import { AddTicketDetails } from "../../../masters/items/queries/mutations";
import { MapsContext } from "../../../maps/context/context";
import { toIsoDate } from "../../../../../../utils/UtilFunctions";
import useServerDateandTime from "../../../../../../customHooks/useServerDateandTime";
import useLoggedInUserDetails from "../../../../../../customHooks/useLoggedInUserDetails";
import { AtsTicketsByNodeForStatus, GetTicketDetailsForFollowUp } from "../../../masters/items/queries/queries";
import MessageModal from "../../../../../../customComponents/MessageModal";
import { GetTickets } from "../../../../../../queries/queries";
import
{
  AtsTicketsOrderField,
  TicketsQueryType,
} from "../../../../../../queries/types";
import { GetDashboardTicketCount } from "../queries";
import { useDebounce } from "../../../../../../customHooks/useDebounce";
interface Props
{
  setDrawerFlag: React.Dispatch<React.SetStateAction<StateTypes>>;
  id: number;
}
const AssignTechnician = ( { setDrawerFlag, id }: Props ) =>
{
  const { customer_id } = useUrlParams();
  const [ searchData, setSearchData ] = useState( "" );
  const debouncedSearch = useDebounce(searchData, debouncedDelay);

  const [ message, setMessage ] = useState( emptyMessage );
  const { state: mapsState, dispatch } = useContext( MapsContext );
  const { serverDate } = useServerDateandTime();
  const { user_details } = useLoggedInUserDetails();

  const [ GetEmployees, { data } ] = useLazyQuery<GetEmpResult, GetEmpVars>(
    GetEmp
  );

  useEffect( () =>
  {
    const fetchData = async () =>
    {
      try
      {
        if ( customer_id )
        {
          GetEmployees( {
            variables: {
              after: null,
              customer_id,
              first: ROWS_PER_PAGE,
              input: {
                queryType: EmpQueryType.BY_TYPE,
                empType: [ empType.TECHNICIAN, empType.VENDOR_MANAGER ],
                companyID: 0,
                ldgrID: id ? id : 0,
                siteID: 0,
                subsidiaryID: 0,
              },
              orderBy: {
                direction: OrderDirection.ASC,
                field: EmpMasterOrderField.NAME,
              },
              name: debouncedSearch,
            },
          } );
        }
      } catch ( err )
      {
        console.error( ( err as Error ).message );
      }
    };
    fetchData();
  }, [ customer_id, GetEmployees, empType, debouncedSearch ] );

  const [ addTicket ] = useMutation<
    AddTicketDetailsResult,
    AddTicketDetailsVariables
  >( AddTicketDetails, {
    onError: ( e ) =>
      setMessage( {
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      } ),
  } );

  const handleSubmit = async ( empId: number ) =>
  {
    try
    {
      if ( customer_id )
      {
        const assignEmp = addTicket( {
          variables: {
            customerID: customer_id!,
            ticketID: mapsState.ticketId,
            todaysDate: toIsoDate( serverDate ),
            user_details,
            deviceTypes: [],
            input: {
              assignedID: empId ? empId : 0,
              status: TicketStatus.ASSIGNED,
              remarks: EMPTY_STRING,
              imagesPath: EMPTY_STRING,
            },
            assetDetails: [],
          },
          refetchQueries: [
            {
              query: GetTicketDetailsForFollowUp,
              variables: {
                customerID: customer_id!,
                ticketID: mapsState.ticketId,
              },
            },
            {
              query: GetTickets,
              variables: {
                after: null,
                first: ROWS_PER_PAGE,
                name: debouncedSearch,
                orderBy: {
                  direction: OrderDirection.ASC,
                  field: AtsTicketsOrderField.TICKET_NO,
                },
                companyID: 0,
                customerID: customer_id,
                subsidiaryID: 0,
                junctionID: 0,
                reason: "",
                startDate: undefined,
                endDate: undefined,
                input: {
                  itemID: 0,
                  ldgrID: 0,
                  stckCategoryID: 0,
                  stckGroupID: 0,
                  stckManufacturerID: 0,
                  stckSubCategoryID: 0,
                  stckUomID: 0,
                  query_type: TicketsQueryType.ALL,
                  itemDetailsID: 0,
                  status: [ TicketStatus.ASSIGNED ],
                  priority: [],
                  empID: user_details.id!,
                },
                siteID: 0,
              },
            },
            {
              query: GetDashboardTicketCount,
              variables: {
                customerID: customer_id ? customer_id : 0,
                empID: user_details.id ? user_details.id : 0,
              },
            },
            {
              query: AtsTicketsByNodeForStatus,
              variables: {
                id: mapsState.ticketId,
              },
            }
          ],
        } );
        const { data } = await assignEmp;

        if ( data && data.AddTicketDetails )
        {
          setMessage( {
            flag: true,
            message: "Employee Assigned Successfully",
            operation: Operation.CREATE,
          } );
        }
      }
    } catch ( err )
    {
      setMessage( {
        flag: true,
        message: ( err as Error ).message,
        operation: Operation.NONE,
      } );
    }
  };

  const handleClose = () =>
  {
    setMessage( emptyMessage );
    if ( message.operation !== Operation.NONE )
    {
      setDrawerFlag( {
        flag: false,
        vendorId: 0,
      } );
    }
  };

  return (
    <div className="assign-technician">
      <div className="assign-technician__title">
        <Title>Assign Technician</Title>
        <img
          src={Close}
          alt=""
          onClick={() =>
            setDrawerFlag( {
              flag: false,
              vendorId: 0,
            } )
          }
        />
      </div>
      <div className="assign-technician__search">
        <Input
          id="data_search"
          placeholder="Search..."
          onChange={( e ) =>
          {
            setSearchData( e.target.value );
          }}
        />
      </div>
      <div className="assign-technician__ul">
        {data ? (
          data.GetEmp.edges.map( ( res, index ) =>
          {
            return (
              <li>
                <div>
                  <span>{index + 1}.</span>
                  <img src="" alt="" /> <b>{res.node.name}</b>{" "}
                  <span className="font-grey">({res.node.empType})</span>
                </div>
                <button
                  className="assign-technician__ul--assign"
                  onClick={() => handleSubmit( res.node.id )}
                >
                  Assign <img src={Assign} alt="" />
                </button>
              </li>
            );
          } )
        ) : (
          <></>
        )}
      </div>
      <div className="assign-technician__button row g-0">
        <div className="col">
          <Button
            mode="cancel"
            onClick={() =>
              setDrawerFlag( {
                flag: false,
                vendorId: 0,
              } )
            }
          />
        </div>
        <div className="col flex-end">
          <div className="overall-total-count">
            Total emp : <b>{data ? data.GetEmp.totalCount : 0}</b>
          </div>
        </div>
      </div>
      <MessageModal
        handleClose={handleClose}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />
    </div>
  );
};

export default AssignTechnician;
